import React from "react";
import { MapPin, Phone, Navigation, ExternalLink } from "lucide-react";

const LAT = 44.4652209;
const LNG = 26.1171193;
const ADDRESS = "Strada Grigore Moisil Nr. 38, Sector 2, București";
const PHONE = "0725 399 235";
const PHONE_LINK = "tel:+40725399235";
const MAPS_URL = `https://www.google.com/maps/search/?api=1&query=${LAT},${LNG}&query_place_id=`;
const WAZE_URL = `https://waze.com/ul?ll=${LAT},${LNG}&navigate=yes&q=${encodeURIComponent("AutoPro Daune")}`;
const EMBED_PLACE_URL = `https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d500!2d${LNG}!3d${LAT}!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDTCsDI3JzU0LjgiTiAyNsKwMDcnMDEuNiJF!5e0!3m2!1sro!2sro`;

const LocationSection = ({ variant = "landing" }) => {
  const isLanding = variant === "landing";

  return (
    <section id="locatie" className={isLanding ? "py-20 bg-white" : ""} data-testid="location-section">
      <div className={isLanding ? "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" : ""}>
        {isLanding && (
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Centrul nostru de constatare</h2>
            <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">Vino la sediul nostru pentru constatare sau reconstatare.</p>
          </div>
        )}

        <div className={`grid ${isLanding ? "lg:grid-cols-2" : "lg:grid-cols-2"} gap-8 items-start`}>
          {/* Map */}
          <div className="rounded-2xl overflow-hidden shadow-lg border border-gray-100 aspect-[4/3]" data-testid="google-map-embed">
            <iframe
              src={EMBED_PLACE_URL}
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: "320px" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="AutoPro Daune - Locatie"
            />
          </div>

          {/* Info + Buttons */}
          <div className="space-y-6">
            {/* Address */}
            <div className="flex items-start gap-4 p-5 bg-gray-50 rounded-2xl" data-testid="location-address">
              <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center shrink-0">
                <MapPin className="w-6 h-6 text-emerald-600" />
              </div>
              <div>
                <p className="font-bold text-gray-900 mb-1">Adresa</p>
                <p className="text-gray-600">{ADDRESS}</p>
              </div>
            </div>

            {/* Phone */}
            <a href={PHONE_LINK} className="flex items-start gap-4 p-5 bg-gray-50 rounded-2xl hover:bg-emerald-50 transition-colors group" data-testid="location-phone">
              <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center shrink-0 group-hover:bg-emerald-200 transition-colors">
                <Phone className="w-6 h-6 text-emerald-600" />
              </div>
              <div>
                <p className="font-bold text-gray-900 mb-1">Telefon</p>
                <p className="text-emerald-600 font-semibold text-lg">{PHONE}</p>
              </div>
            </a>

            {/* Navigation Buttons */}
            <div className="grid grid-cols-2 gap-4" data-testid="navigation-buttons">
              <a
                href={WAZE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-3 px-6 py-5 bg-[#33ccff] text-white rounded-2xl font-bold text-lg hover:brightness-110 transition-all shadow-lg shadow-[#33ccff]/30 hover:-translate-y-0.5"
                data-testid="waze-button"
              >
                <Navigation className="w-6 h-6" />
                Waze
              </a>
              <a
                href={MAPS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-3 px-6 py-5 bg-[#4285F4] text-white rounded-2xl font-bold text-lg hover:brightness-110 transition-all shadow-lg shadow-[#4285F4]/30 hover:-translate-y-0.5"
                data-testid="google-maps-button"
              >
                <ExternalLink className="w-6 h-6" />
                Google Maps
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
